/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { AsyncThunkError, AsyncThunkErrorPayload } from "~/state/types";

const createThunkError = ({ apiErrorCode, message, data }: Partial<AsyncThunkErrorPayload>): AsyncThunkError => ({
  thunkError: {
    apiErrorCode: apiErrorCode ?? null,
    message: message ?? null,
    data: data ?? null,
  },
});

export default createThunkError;
